import { render, staticRenderFns } from "./ModalTypeServiceFilter.vue?vue&type=template&id=b152f712&scoped=true"
import script from "./ModalTypeServiceFilter.vue?vue&type=script&lang=js"
export * from "./ModalTypeServiceFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b152f712",
  null
  
)

export default component.exports